import React, { useEffect, useState } from "react";
import { DatePicker, Input, Select } from "uxp/components";
import './ExtendedDatePicker.scss';
const regExp = /^([+-]?)(\d+)\s*(m|h|d|w|mo|y)$/i;
export function isRelativeDate(ds) {
    return regExp.test(ds);
}
export function parseRelativeDate(ds) {
    const match = ds.match(regExp);
    if (match) {
        const [_, sign, number, bucket] = match;
        return {
            before: sign == '-',
            count: parseInt(number, 10),
            bucket
        };
    }
    return {
        before: true,
        count: 0,
        bucket: 'd'
    };
}
export function serialiseRelativeDate(rd) {
    const ds = `${rd.before ? '-' : '+'}${rd.count}${rd.bucket}`;
    return ds;
}
export const ExtendedDatePicker = props => {
    const { datetime, onChange } = props;
    const [rD, setRD] = useState({
        before: true,
        count: 0,
        bucket: 'd'
    });
    const [isRD, setIsRD] = useState(true);
    useEffect(() => {
        if (typeof datetime == 'string' && isRelativeDate(datetime)) {
            const _rd = parseRelativeDate(datetime);
            setRD(_rd);
            setIsRD(true);
        }
        else {
            setIsRD(false);
        }
    }, [datetime]);
    function updateRD(field, val) {
        const _rd = Object.assign({}, rD);
        _rd[field] = val;
        onChange(serialiseRelativeDate(_rd));
        setRD(_rd);
    }
    return React.createElement("div", { className: "lucy-query-engin-date-time-picker-component-container-821e8852" },
        React.createElement("div", { className: "lucy-query-engine-date-time-container-821e8852" },
            React.createElement("div", { className: "lucy-query-engine-date-time-container-type-picker-821e8852" },
                React.createElement(Select, { selected: isRD ? 'relative' : 'specific', onChange: s => setIsRD(s == 'relative'), options: [{
                            label: 'Relative date',
                            value: 'relative'
                        }, {
                            label: 'Specific date',
                            value: 'specific'
                        }], 
                    // className="lucy-query-engine-dp-input"
                    dropdownClassname: "lucy-query-engin-dp-dropdown" })),
            isRD ? React.createElement(React.Fragment, null,
                React.createElement(Input, { type: "number", value: (rD.count || 0).toString(), onChange: s => updateRD('count', Number(s)), className: "lucy-query-engine-dp-input-821e8852" }),
                React.createElement(Select, { selected: rD.bucket || 'd', onChange: s => updateRD('bucket', s), options: [{
                            label: 'Minute(s)',
                            value: 'm'
                        }, {
                            label: 'Hour(s)',
                            value: 'h'
                        }, {
                            label: 'Day(s)',
                            value: 'd'
                        }, {
                            label: 'Week(s)',
                            value: 'w'
                        }, {
                            label: 'Month(s)',
                            value: 'mo'
                        }, {
                            label: 'Year(s)',
                            value: 'y'
                        }], className: "lucy-query-engine-dp-input-821e8852", dropdownClassname: "lucy-query-engin-dp-dropdown" }),
                React.createElement("div", { className: "lucy-query-engine-date-time-label-821e8852" }, "before current date ")) : React.createElement(DatePicker, { title: "date", date: typeof datetime != 'string' || typeof datetime == 'string' && !isRelativeDate(datetime) ? datetime : '', onChange: date => onChange(date) })));
};
